// Pull the SCSS bundle into the rspack graph. `CssExtractRspackPlugin`
// extracts it into a real CSS asset (`main.css` in MF, `main.[hash].css`
// in standalone). HtmlRspackPlugin auto-injects the standalone build's
// `<link>` into `static/index.html`. In MF mode the host loads our `./app`
// chunk via its manifest and `mount()` injects the `<link>` at runtime.
import '../static/styles/main.scss';

import { mountStandalone } from './bootstrap';

// Standalone entry. This chunk only executes when the NG Meet bundle is loaded
// directly (the shipping app, or the MF bundle served at :8081 for debugging).
// When TeamHub consumes us as an MF remote it imports `./app` and calls
// `mount()` instead, so this code never runs in the host.
const rootElement = document.getElementById('root');
if (rootElement) {
  mountStandalone(rootElement);
} else {
  throw new Error('Root element not found');
}
